<template>
  <section>
    <div class="row">
      <div class="form-group">
        <label>
          Delivery Configuration
          <i class="text-danger text-sm"
          >
            {{(basedOnDistance) ? '(based on distance range)' : '(based on cost range)'}}
          </i>
          <button
              v-if="!readOnly"
              type="button"
              v-on:click="addDeliveryConfig()"
              class="btn btn-primary btn-xs">
            <i class="fa fa-plus"/>
          </button>
        </label>
        <table class="table table-bordered"
                 :key="randomValue" >
            <thead>
            <tr>
              <th>From ({{ placeholder }})</th>
              <th>To ({{ placeholder }})</th>
              <th>Cost (Rs.)</th>
              <th v-if="!readOnly" class="text-center">
                <i class="fa fa-bolt fa-lg"/>
              </th>
            </tr>
          </thead>
          <tbody v-if="!basedOnDistance">
          <tr
              v-for="(config, index) in costBased"
              v-bind:key="index"
          >
            <td>{{config.from}}</td>
            <td>{{config.to}}</td>
            <td>{{config.cost}}</td>
            <td v-if="!readOnly" class="center">
              <a class="fa fa-pencil fa-lg"
                 title="Edit"
                 v-on:click="addDeliveryConfig(index)"
              /> |
              <a class="fa fa-trash fa-lg"
                 title="Delete"
                 v-on:click="deleteDeliveryConfig(index)"
              />
            </td>
          </tr>
          <tr v-if="costBased === null || costBased.length === 0">
            <td colspan="4">No Configurations Exist</td>
          </tr>
          </tbody>

          <tbody v-else>
          <tr
              v-for="(config, index) in distanceBased"
              v-bind:key="index"
          >
            <td>{{config.from_km}}</td>
            <td>{{config.to_km}}</td>
            <td>{{config.cost}}</td>
            <td v-if="!readOnly" class="center">
              <a class="fa fa-pencil fa-lg"
                 title="Edit"
                 v-on:click="addDeliveryConfig(index)"
              />|
              <a class="fa fa-trash fa-lg"
                 title="Delete"
                 v-on:click="deleteDeliveryConfig(index)"
              />
            </td>
          </tr>
          <tr v-if="distanceBased === null || distanceBased.length === 0">
            <td colspan="4">No Configurations Exist</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import store from "@/store";

export default {
  name: "CostBasedConfiguration",
  props: {
    costBasedDeliveryConfig: {
      type: String,
      required: false
    },
    distanceBasedDeliveryConfig: {
      type: String,
      required: false
    },
    basedOnDistance: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      readOnly: store.state.user.userRolesById[0].role.split('_')[1] === 'AGENT',
      costBased: [],
      distanceBased: [],
      randomValue: Math.random(),
    }
  },
    computed : {
      placeholder() {
          return this.basedOnDistance ? 'KM' : 'Rs.'
      }
    },
  watch: {
    costBasedDeliveryConfig (value) {
      if (value) {
        this.costBased = JSON.parse(value);
        this.placeholder = "Rs."
      }
      this.randomValue = Math.random();
    },
    distanceBasedDeliveryConfig (value){
      if (value) {
        this.distanceBased = JSON.parse(value);
      }
      this.randomValue = Math.random();
    }
  },
  methods: {
    addDeliveryConfig (index) {
      let self = this;
      swal({
        title: 'Enter Configuration',
        showCancelButton: true,
        confirmButtonText: 'Save',
        html:
            '<input id="swal-input1" type="number" placeholder="From ' + self.placeholder + '" class="form-control" min="0"><br/>' +
            '<input id="swal-input2" type="number" placeholder="To  ' + self.placeholder + '" class="form-control" min="0"><br/>' +
            '<input id="swal-input3" type="number" placeholder="Cost (Rs.)" class="form-control" min="0">',
        preConfirm: function () {
          return new Promise(function (resolve) {
            if(self.basedOnDistance){
              resolve({
                from_km: parseInt($('#swal-input1').val()),
                to_km: parseInt($('#swal-input2').val()),
                cost: parseInt($('#swal-input3').val())
              })
            }else {
              resolve({
                from: parseInt($('#swal-input1').val()),
                to: parseInt($('#swal-input2').val()),
                cost: parseInt($('#swal-input3').val())
              })
            }
          })
        },
        onOpen: function () {
          $('#swal-input1').focus();
          if (index || index === 0) {
            let deliveryConfig = (!self.basedOnDistance) ? self.costBased[index] : self.distanceBased[index]
            $('#swal-input1').val( (!self.basedOnDistance) ? deliveryConfig.from : deliveryConfig.from_km);
            $('#swal-input2').val((!self.basedOnDistance) ? deliveryConfig.to : deliveryConfig.to_km);
            $('#swal-input3').val(deliveryConfig.cost);
          }
        }
      }).then(function (result) {
        if(result.dismiss === "overlay" || result.dismiss === "cancel") {
          return false;
        }
        if(result.value !== undefined) {
          if (index || index === 0) {
            if(self.basedOnDistance){
              self.distanceBased[index].from_km = parseInt($('#swal-input1').val())
              self.distanceBased[index].to_km = parseInt($('#swal-input2').val())
              self.distanceBased[index].cost = parseInt($('#swal-input3').val())
            }else{
              self.costBased[index].from = parseInt($('#swal-input1').val())
              self.costBased[index].to = parseInt($('#swal-input2').val())
              self.costBased[index].cost = parseInt($('#swal-input3').val())
            }
          } else {
            if(self.basedOnDistance) {
              self.distanceBased.push(result.value);
            }else
              self.costBased.push(result.value);
          }
        }
      }).catch(swal.noop)
    },
    deleteDeliveryConfig (index) {
      if(this.basedOnDistance) {
        this.distanceBased.splice(index, 1);
      }else{
        this.costBased.splice(index, 1);
      }

    }
  }
}
</script>

<style scoped>

</style>